export default __webpack_public_path__ + "static/media/dot.c37d959e.svg";